/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'elegant',
    quality: 0.3,
    mana: 1,
    dexterity: 2
}